import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { ProfileApi } from '@shared/api';

interface SecurityQuestionsType {
  data: string[];
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useGetSecurityQuestionsStore = create<SecurityQuestionsType>((set) => ({
  loading: false,
  data: [],
  error: null,

  get: async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProfileApi.getSecurityQuestions(signal);
      set({ loading: false, data: result ?? [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, data: [], error: null }),
}));
